var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIconV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 423,
    viewBox: "0 0 175 423",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.48 300L12.5196 300C9.1992 300 6.0148 298.662 3.66691 296.281C1.31903 293.899 -2.69564e-06 290.669 -2.54842e-06 287.301L0 229L34.9903 229L34.9903 264.508L139.994 264.508L139.994 229L175 229L175 287.301C175 290.669 173.681 293.899 171.333 296.281C168.985 298.662 165.801 300 162.48 300Z",
    fill: "#84BBAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.48 123L12.5196 123C9.1992 123 6.0148 124.338 3.66692 126.719C1.31903 129.101 -4.07873e-07 132.331 -5.55093e-07 135.699L-3.10351e-06 194L34.9903 194L34.9903 158.508L139.994 158.508L139.994 194L175 194L175 135.699C175 132.331 173.681 129.101 171.333 126.719C168.985 124.338 165.801 123 162.48 123Z",
    fill: "#84BBAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.481 17L47.5192 17C44.1989 17 41.0146 18.3379 38.6668 20.7195C36.319 23.101 35 26.3311 35 29.699L35 88L70.0054 88L70.0054 52.5082L105.011 52.5082L105.011 88L140 88L140 29.6991C140 26.3311 138.681 23.101 136.333 20.7195C133.985 18.3379 130.801 17 127.481 17V17Z",
    fill: "#84BBAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.481 406L47.5192 406C45.8738 406 44.2446 405.671 42.7246 405.032C41.2046 404.393 39.8238 403.456 38.6611 402.276C37.4984 401.095 36.5765 399.693 35.9483 398.151C35.3201 396.609 34.9979 394.956 35 393.287L35 335L70.0054 335L70.0054 370.5L105.011 370.5L105.011 335L140 335L140 393.287C140.002 394.956 139.68 396.609 139.052 398.151C138.423 399.693 137.502 401.095 136.339 402.276C135.176 403.456 133.795 404.393 132.275 405.032C130.755 405.671 129.126 406 127.481 406Z",
    fill: "#84BBAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconV);
export default __webpack_public_path__ + "static/media/logo-icon-v.88ffbf1012455af44141cec437189e03.svg";
export { ForwardRef as ReactComponent };